import { currencyTypeEnum, virtualPosEnum, subProductEnum } from '../enums';
import { mapToVirtualValue } from '~/mappers';
import * as moment from 'moment';
export var mapRequestGenerateCommerceCode = function mapRequestGenerateCommerceCode(_ref) {
	var state = _ref.state,
	    commercialTariffResult = _ref.commercialTariffResult,
	    isNotBimoney = _ref.isNotBimoney,
	    isVirtual = _ref.isVirtual,
	    user = _ref.user,
	    masterData = _ref.masterData;
	var channelName = user.channelName,
	    subChannelName = user.subChannelName,
	    groupChannelName = user.groupChannelName,
	    username = user.username;
	var mcci = commercialTariffResult.mcci,
	    mccn = commercialTariffResult.mccn,
	    mccnName = commercialTariffResult.mccnName,
	    currency = commercialTariffResult.currency,
	    paymentData = commercialTariffResult.paymentData,
	    debitCommission = commercialTariffResult.debitCommission,
	    creditCommission = commercialTariffResult.creditCommission;
	var idTransaction = state.idTransaction,
	    validateCrmClientData = state.validateCrmClientData,
	    rucValidation = state.rucValidation,
	    osvType = state.osvType,
	    businessSchedule = state.businessSchedule,
	    legalRepresentativeData = state.legalRepresentativeData,
	    virtual = state.virtual,
	    installationSchedule = state.installationSchedule,
	    posSelected = state.posSelected,
	    afilliationSummary = state.afilliationSummary;
	var _state$businessData = state.businessData,
	    commerceData = _state$businessData.commerceData,
	    commercialAddress = _state$businessData.commercialAddress,
	    administrativeAddress = _state$businessData.administrativeAddress,
	    refData = _state$businessData.refData;
	var ruc = rucValidation.ruc,
	    businessName = rucValidation.businessName;
	var pos = posSelected.pos,
	    TipoConexion = posSelected.TipoConexion;


	creditCommission = creditCommission || 3.99;
	debitCommission = debitCommission || 2.99;

	var developer = pos == virtualPosEnum.PAGO_WEB ? virtual.webSite.developer : virtual.app.developer;
	var integration = pos == virtualPosEnum.PAGO_WEB ? virtual.webSite.integration : virtual.app.integration;

	var subReason = void 0,
	    reason = void 0,
	    subProductCode = void 0,
	    equipmentType = void 0,
	    idTradePlan = '',
	    isMulticommerce = false;

	switch (Number(state.osvType.osvType)) {
		// individual
		case 1:
			reason = isNotBimoney ? 'INS' : 'INS_MLT';
			subReason = isNotBimoney ? 'INS_0' : 'INS_MLT';
			break;
		// multicomercio
		case 2:
			reason = 'INS';
			subReason = 'INS_MLT';
			isMulticommerce = true;
			mccn = '0100';
			break;
		// código hijo
		case 3:
			reason = 'RGS';
			subReason = 'RGS_0';
			mccn = '0100';
			break;
	}

	if (isVirtual) {
		idTradePlan = 'CE';
		switch (pos) {
			case virtualPosEnum.PAGO_APP:
				subProductCode = subProductEnum.PAGO_APP;
				idTradePlan += 'APP0000' + (currency === currencyTypeEnum.SOLES ? '3' : '4');
				break;
			case virtualPosEnum.PAGO_LINK:
				subProductCode = subProductEnum.PAGO_LINK;
				idTradePlan += 'PAGLIK0' + (currency === currencyTypeEnum.SOLES ? '7' : '8');
				break;
			case virtualPosEnum.PAGO_WEB:
				subProductCode = subProductEnum.PAGO_WEB;
				idTradePlan += 'PAGOWB0' + (currency === currencyTypeEnum.SOLES ? '5' : '6');
				break;
		}
	} else subProductCode = 'BP';

	switch (TipoConexion) {
		case 'RTC':
			equipmentType = 'DPA';
			break;
		case 'IPC':
			equipmentType = 'PIP';
			break;
		case 'CEL':
			equipmentType = 'CLX';
			break;
		default:
			equipmentType = '';
	}

	var LegalBirthDate = moment(legalRepresentativeData.birthdate).format('YYYY-MM-DD');
	var equipmentQuantity = 0;

	if (state.afilliationSummary.equipment) {
		equipmentQuantity = parseInt(state.afilliationSummary.equipment.value, 10);
		if (isNaN(equipmentQuantity)) equipmentQuantity = 1;
	}

	// CAMBIO: Documento Funcional Necomplus Partner de Red 2.0
	var providerUsername = '';
	switch (groupChannelName) {
		case "DEALER NECOMPLUS PDR":
			providerUsername = "NPLPDR"; //antes: 'NPL PDR'
			break;
		case "DEALER NECOMPLUS LIMA":
		case "DEALER NECOMPLUS PROVINCIA":
			providerUsername = "NPLPDC"; //antes: 'NPL'
			break;
		default:
			providerUsername = "SCRPDC"; //antes: 'VNT'
	}

	var paymentMethod = '';
	switch (afilliationSummary.posName) {
		case "Pago Link":
			paymentMethod = 'MP01';
			break;
		case "Telepago":
			paymentMethod = 'MP02';
			break;
		case "Pago Web":
			paymentMethod = 'MP03';
			break;
	}

	var request = {
		// idTransaction,
		// idTradePlan,
		// ciiuSunat: validateCrmClientData && `${validateCrmClientData.SIC} - ${validateCrmClientData.Desc}`.trim(),
		// ruc,
		// lastRequestToSunatDate: rucValidation.consultDate,
		// businessName,
		// commercialName: commerceData.tradeName,
		// // businessName: commerceData.commercialBusiness ? commerceData.commercialBusiness.Description : '',
		// businessEmail: commerceData.email,
		// personalDataTreatment: afilliationSummary.authorizePersonalDataTreatment,
		// currency: currency === currencyTypeEnum.DOLARES ? 'DOL' : 'SOL',
		// parentCommerceCode: osvType.commercialCode ? osvType.commercialCode : '',
		// subProductCode,
		// productCode: isVirtual ? 'CE' : 'BS',
		// mcci,
		// mccnName,
		// mccn,
		// bankCode: paymentData.bankName,
		// bankAccountType: paymentData.accountType,
		// bankAccountNumber: paymentData.accountNumber,
		// bankAccountNumberFormatted: paymentData.alternativeAccountNumber,
		// creditCommission,
		// debitCommission,
		// isMulticommerce,
		// administrativeAddress: {
		// 	department: administrativeAddress.department.UbiDep,
		// 	province: administrativeAddress.province.UbiPro,
		// 	district: administrativeAddress.district.UbiDis,
		// 	typeOfRoad: (administrativeAddress.typeOfRoad || { Code: '' }).Code,
		// 	nameOfRoad: administrativeAddress.nameOfRoad,
		// 	numberOfRoad: administrativeAddress.numberOfRoad,
		// 	// plusCode: administrativeAddress.plusCode,
		// 	km: administrativeAddress.km,
		// 	block: administrativeAddress.block,
		// 	allotment: administrativeAddress.allotment,
		// 	interiorType: (administrativeAddress.interiorType || { Code: '' }).Code,
		// 	interior: administrativeAddress.interior,
		// 	reference: administrativeAddress.reference,
		// 	typeUrbanHabilitation: administrativeAddress.typeUrbanHabilitation.Code,
		// 	urbanHabilitation: administrativeAddress.urbanHabilitation,
		// 	cellPhone: administrativeAddress.cellPhone,
		// 	prefix: administrativeAddress.prefix,
		// 	phone: administrativeAddress.landline
		// },
		// commercialAddress: {
		// 	department: commercialAddress.department.UbiDep,
		// 	province: commercialAddress.province.UbiPro,
		// 	district: commercialAddress.district.UbiDis,
		// 	typeOfRoad: (commercialAddress.typeOfRoad || { Code: '' }).Code,
		// 	nameOfRoad: commercialAddress.nameOfRoad,
		// 	numberOfRoad: commercialAddress.numberOfRoad,
		// 	// plusCode: commercialAddress.plusCode,
		// 	km: commercialAddress.km,
		// 	block: commercialAddress.block,
		// 	allotment: commercialAddress.allotment,
		// 	interiorType: (commercialAddress.interiorType || { Code: '' }).Code,
		// 	interior: commercialAddress.interior,
		// 	reference: commercialAddress.reference,
		// 	typeUrbanHabilitation: commercialAddress.typeUrbanHabilitation.Code,
		// 	urbanHabilitation: commercialAddress.urbanHabilitation,
		// 	cellPhone: commercialAddress.cellPhone,
		// 	prefix: commercialAddress.prefix,
		// 	phone: commercialAddress.landline
		// },
		// scheduleAttention: {
		// 	daysNumber: Array.isArray(businessSchedule.schedule) ? businessSchedule.schedule.filter(day => day > -1) : [],
		// 	initTime: businessSchedule.startTime,
		// 	endTime: businessSchedule.endTime
		// },
		// legalRepresentative: {
		// 	fullName: legalRepresentativeData.firstName,
		// 	paternalName: legalRepresentativeData.paternalName,
		// 	maternalName: legalRepresentativeData.maternalName,
		// 	documentType: mapToVirtualValue('tipoDocumento', legalRepresentativeData.documentType.Code),
		// 	documentNumber: legalRepresentativeData.documentNumber,
		// 	phone: legalRepresentativeData.secondPhone,
		// 	cellPhone: legalRepresentativeData.cellPhone,
		// 	email: legalRepresentativeData.email,
		// 	birthdate: LegalBirthDate,
		// 	lastRequestToSunatDate: legalRepresentativeData.consultDate
		// },
		// administrativePlatformUser: {
		// 	fullName: virtual.user.fullname,
		// 	email: virtual.user.email,
		// 	phone: virtual.user.phone
		// },
		// app: {
		// 	name: virtual.app.name,
		// 	link: virtual.app.link,
		// 	platform: virtual.app.platform ? (masterData.platform.find(p => p.value === virtual.app.platform) || { text: null }).text : null,
		// 	integration: integration.paymentForm
		// },
		// developer: {
		// 	developmentType: developer.developmentType ? (masterData.development.find(p => p.value === developer.developmentType) || { text: null }).text : null,
		// 	company: developer.company ? developer.company : null,
		// 	fullName: developer.fullname ? developer.fullname : null,
		// 	email: developer.email ? developer.email : null,
		// 	phone: developer.phone ? developer.phone : null
		// },
		// websiteUrl: virtual.webSite.url,
		// subReason,
		// reason,
		// equipmentQuantity,
		// connectionType: TipoConexion,
		// installationContact: {
		// 	fullName: `${installationSchedule.name || ''} ${installationSchedule.paternalLastname || ''} ${installationSchedule.maternalLastname || ''}`.trim(),
		// 	cellphone: installationSchedule.phone,
		// 	email: installationSchedule.email,
		// 	phone: installationSchedule.phone
		// },
		// channelName: user.channelName,
		// subChannelName: user.subChannelName,
		// groupChannelName: user.groupChannelName,
		// equipmentType,
		// dues: afilliationSummary.dues ? afilliationSummary.dues.value : null

		audit: {
			appId: 'PCRM001V1',
			usuario: username, // null
			ipServidor: null, // setea servicio
			transaccionId: idTransaction,
			origen: null // setea servicio (clientAppName)
		},

		//afiliarComercioRequest
		clientePadre: {
			id: '0' // null
		},
		cliente: {
			id: '0', // null
			ruc: ruc,
			razonSocial: businessName,
			razonSocialAbreviado: commerceData.tradeName, // null
			nombreComercial: commerceData.tradeName, // null
			tipo: 'N',
			ttoDatosPersonales: afilliationSummary.authorizePersonalDataTreatment,
			proveedorCampo: providerUsername,
			habilitadoSunat: '01',
			fechaConsultaSunat: rucValidation.consultDate,
			estaListasNegras: false,
			estaGesintelPLAFT: '01',
			actEconomica: validateCrmClientData && (validateCrmClientData.SIC + ' - ' + validateCrmClientData.Desc).trim(),
			segmento: 'A',
			correoDAE: commerceData.email, // null
			canal: channelName,
			subCanal: subChannelName,
			grupoCanal: groupChannelName
		},
		contactos: {
			tipo: '01',
			nombres: legalRepresentativeData.firstName,
			primerApellido: legalRepresentativeData.paternalName,
			segundoApellido: legalRepresentativeData.maternalName,
			tipoDocumento: mapToVirtualValue('tipoDocumento', legalRepresentativeData.documentType.Code),
			numeroDocumento: legalRepresentativeData.documentNumber,
			cargo: 'Z002',
			telefonoFijo: legalRepresentativeData.secondPhone,
			telefonoMovil: legalRepresentativeData.cellPhone,
			correo: legalRepresentativeData.email, // null
			fechaNacimiento: LegalBirthDate,
			fechaConsultaSunat: legalRepresentativeData.consultDate,
			estaListasNegras: false,
			nacionalidad: 'Peruana', // null
			canal: channelName,
			subCanal: subChannelName,
			grupoCanal: groupChannelName
		},
		direccionAdministrativa: {
			tipo: 'A',
			tipoVia: (administrativeAddress.typeOfRoad || { Code: '' }).Code,
			nombreVia: administrativeAddress.nameOfRoad,
			numeroVia: administrativeAddress.numberOfRoad,
			departamento: administrativeAddress.department.UbiDep,
			descDepartamento: administrativeAddress.department.Name,
			provincia: administrativeAddress.province.UbiPro,
			descProvincia: administrativeAddress.province.Name,
			distrito: administrativeAddress.district.UbiDis,
			descDistrito: administrativeAddress.district.Name,
			referencia: administrativeAddress.reference,
			mz: administrativeAddress.block, // null
			tipoHabilitacionUrbana: administrativeAddress.typeUrbanHabilitation, // null
			habilitacionUrbana: administrativeAddress.urbanHabilitation, // null
			lote: administrativeAddress.allotment, // null
			km: administrativeAddress.km, // null
			tipoInterior: (administrativeAddress.interiorType || { Code: '' }).Code, // null
			interior: administrativeAddress.interior, // null
			tipoConglomerado: 'BLK', // null
			conglomerado: '1', // null 
			telefono1: administrativeAddress.cellPhone,
			telefono2: administrativeAddress.prefix + administrativeAddress.landline // null
		},
		direccionComercial: {
			tipo: 'C',
			tipoVia: (commercialAddress.typeOfRoad || { Code: '' }).Code,
			nombreVia: commercialAddress.nameOfRoad,
			numeroVia: commercialAddress.numberOfRoad,
			departamento: commercialAddress.department.UbiDep,
			descDepartamento: commercialAddress.department.Name,
			provincia: commercialAddress.province.UbiPro,
			descProvincia: commercialAddress.province.Name,
			distrito: commercialAddress.district.UbiDis,
			descDistrito: commercialAddress.district.Name,
			referencia: commercialAddress.reference,
			mz: commercialAddress.block, // null
			tipoHabilitacionUrbana: commercialAddress.typeUrbanHabilitation, // null
			habilitacionUrbana: commercialAddress.urbanHabilitation, // null
			lote: commercialAddress.allotment, // null
			km: commercialAddress.km, // null
			tipoInterior: (commercialAddress.interiorType || { Code: '' }).Code, // null
			interior: commercialAddress.interior, // null
			tipoConglomerado: 'BLK', // null
			conglomerado: '1', // null 
			telefono1: commercialAddress.cellPhone,
			telefono2: commercialAddress.prefix + commercialAddress.landline // null
		},
		horariosAtencion: {
			lunes: false, // null
			martes: false, // null
			miercoles: false, // null
			jueves: false, // null
			viernes: false, // null
			sabado: false, // null
			domingo: false // null
		},
		horasAtencion: {
			horaInicio: businessSchedule.startTime, // null
			horaFin: businessSchedule.endTime // null
		},
		oportunidad: {
			id: '',
			codigoComercio: '',
			codComercioPadre: osvType.commercialCode ? osvType.commercialCode : '', // null
			nombreComercial: commerceData.tradeName,
			correo: commerceData.email,
			proveedorCampo: providerUsername,
			entidadFinanciera: paymentData.bankName,
			tipoCuenta: paymentData.accountType,
			numeroCuenta: paymentData.accountNumber,
			nroCuentaFormateada: paymentData.alternativeAccountNumber,
			mccInternacional: mcci,
			descMCCInternacional: mccnName,
			mccNacional: mccn,
			descMCCNacional: 'AFILIACIONES TARIFA 2010',
			comisionCredito: creditCommission,
			comisionDebito: debitCommission,
			moneda: currency === currencyTypeEnum.DOLARES ? 'DOL' : 'SOL',
			producto: isVirtual ? 'CE' : 'BS',
			subProducto: subProductCode,
			codigoEjecutivo: null, // null
			nombreEjecutivo: null, // null
			tipoDocumentoEjectivo: null, // null
			nroDocumentoEjecutivo: null, // null
			telefonoEjecutivo: null, // null 
			correoEjecutivo: null, // null 
			nombreSupervisor: null, // null
			tipoAfiliacion: '01',
			fechaInicioVigencia: null, // null
			fechaFinVigencia: null, // null 
			codPlanComercio: idTradePlan, // null
			observadoRyC: false,
			estaGesintelPEIRUC: refData[0].AcceptReqd,
			estaGesintelPEPRUC: refData[1].AcceptReqd,
			estaGesintelPEIRL: refData[2].AcceptReqd,
			estaGesintelPEPRL: refData[3].AcceptReqd,
			estaGesintelPLAFTRUC: refData[6].AcceptReqd,
			estaGesintelPLAFTRL: refData[7].AcceptReqd,
			estaListasNegrasTelefonoRL: refData[4].AcceptReqd,
			estaListasNegrasCorreoRL: refData[5].AcceptReqd,
			esMCCRiesgoso: false,
			esMulticomercio: isMulticommerce,
			indicadorRyC1: false,
			indicadorRyC2: false,
			estadoSeguridadRyC: 'SO',
			propietario: legalRepresentativeData.firstName, // null
			codPlusDireAdmin: null, // null
			codPlusDireComer: null, // null
			codigoBID: null, // null
			modalidad: null, // null
			plan: null, // null
			afiliacion: null, // null 
			aceptaTyCContratoAfiiacionWeb: 'true',
			aceptaTyCWeb: 'true',
			permiteDCC: null, // null
			permiteMultimarca: null, // null
			permiteBoletaElectronica: null, // null
			segmento: 'A',
			marcaVisa: true, // null
			marcaMC: true, // null
			marcaAmex: true, // null
			marcaDiners: true, // null
			procesadorVisa: 'VNT', // null
			procesadorMC: 'VNT', // null
			procesadorAmex: 'VNT', // null
			procesadorDiners: 'VNT', // null
			tipoLiquidacionVisa: 'TLA', // null
			tipoLiquidacionMC: 'TLA', // null
			tipoLiquidacionAmex: 'TLA', // null
			tipoLiquidacionDiners: 'TLA', // null
			tipoComercioVisa: '', // null
			tipoComercioMC: '', // null
			tipoComercioAmex: '', // null
			tipoComercioDiners: 'G2', // null
			codComercioVisa: '', // null
			codComercioMC: '', // null
			codComercioDiners: '', // null
			codComercioAmexLiqManual: '', // null
			codComercioAmexLiqAutomatica: '', // null
			canal: channelName,
			subCanal: subChannelName,
			grupoCanal: groupChannelName
		},
		datosComercioElectronico: {
			nombreAdminPMM: virtual.user.fullname, // null
			correoAdminPMM: virtual.user.email, // null
			telefonoAdminPMM: virtual.user.phone, // null
			nombreApp: virtual.app.name, // null
			datosLinkApp: virtual.app.link, // null
			plataformaApp: virtual.app.platform ? (masterData.platform.find(function (p) {
				return p.value === virtual.app.platform;
			}) || { text: null }).text : null, // null
			formularioPago: integration.paymentForm, // null
			modalidadPosWebTiendaVirtual: null, // null
			modalidadUrlDominio: virtual.webSite.url, // null
			paginaWebWebUrlDominio: virtual.webSite.url, // null
			desarrollo: developer.developmentType ? (masterData.development.find(function (p) {
				return p.value === developer.developmentType;
			}) || { text: null }).text : null, // null
			nombreEmpresa: developer.company ? developer.company : null, // null
			nombresDesarrollador: developer.fullname ? developer.fullname : null, // null
			correoContactoDesarrollador: developer.email ? developer.email : null, // null
			telefonoContactoDesarrollador: developer.phone ? developer.phone : null, // null
			posWebTdaVirtualAdapt: '101' // null
		},
		datosRecurrentes: {
			notificaCargoCliente: null, // null
			canal: null, // null
			renovAutoAfiliacion: null, // null
			periodReintentosAuto: null, // null
			nombreAdmin1: null, // null 
			correoAdmin1: null, // null
			telefono1: null, // null
			nombreAdmin2: null, // null
			correoAdmin2: null, // null
			telefono2: null // null
		},
		ticket: {
			tipoMotivo: 'ORD',
			prioridad: '1',
			nombreEncargado: ((installationSchedule.name || '') + ' ' + (installationSchedule.paternalLastname || '') + ' ' + (installationSchedule.maternalLastname || '')).trim(),
			cargoEncargado: 'Administrador',
			telefonoFijoEncargado: installationSchedule.phone,
			telefonoMovilEncargado: installationSchedule.phone,
			motivoOrden: reason,
			subMotivoOrden: subReason,
			indHorarioAcordado: false,
			horarioAcordado: null, // null
			indHorarioSugerido: true,
			canal: channelName,
			subCanal: subChannelName,
			grupoCanal: groupChannelName,
			esPOSPinpadMpos: 'POS01',
			tipoPago: 'TP02',
			numeroCuota: afilliationSummary.dues ? afilliationSummary.dues.value : null,
			medioPago: paymentMethod,
			numeroTrxPago: 'BFGF4',
			tipoEntrega: 'TE01',
			capacitacion: true,
			cantidadEquipos: equipmentQuantity,
			tipoEquipo: equipmentType,
			tipoConexion: TipoConexion,
			codComercioPadreMulticomercio: '',
			nombreMulticomercio: '',
			tipoVigenciaEquipo: '02',
			vigenciaEquipoDesde: '', // null
			vigenciaEquipoHasta: '', // null
			preAutorizacionOSV: false,
			serviciosEquipo: '',
			usuarioCreacion: username
		},
		ticketDireccionComercio: {
			dirEstandar: (commercialAddress.typeOfRoad || { Code: '' }).Code + ' ' + commercialAddress.nameOfRoad + ' ' + commercialAddress.numberOfRoad,
			departamento: commercialAddress.department.UbiDep,
			provincia: commercialAddress.province.UbiPro,
			distrito: commercialAddress.district.UbiDis,
			coordenadaX: null, // null
			coordenadaY: null // null
		},
		ticketHorarioSugerido: {
			lunes: false,
			martes: false,
			miercoles: false,
			jueves: false,
			viernes: false,
			sabado: false,
			domingo: false,
			horaInicio: businessSchedule.startTime,
			horaFin: businessSchedule.endTime
		},
		ticketDireccionRetiroPos: {
			dirEstandar: 'AV. JOSE PARDO 831',
			departamento: '15',
			provincia: '01',
			distrito: '01'
		},
		ticketOpciones: {
			codOpcion: 'OPC', // null
			opcSenalizacion: '041' // null
		},
		ticketOperadores: {
			nombres: 'Miguel', // null
			apellidos: 'Grau', // null
			tipoDocumento: 'D', // null
			numeroDocumento: '23456789', // null
			telefono: '123456676', // null
			correo1: 'mpos@mpos.com', // null
			correo2: 'mpos@mpos.com' // null
		},
		medioDigital: 'Web'
	};

	return request;
};

export var mapRequestGenerateQrCode = function mapRequestGenerateQrCode(_ref2) {
	var state = _ref2.state,
	    commercialTariffResult = _ref2.commercialTariffResult,
	    isNotBimoney = _ref2.isNotBimoney,
	    isVirtual = _ref2.isVirtual,
	    user = _ref2.user,
	    masterData = _ref2.masterData;
	var mcci = commercialTariffResult.mcci,
	    mccn = commercialTariffResult.mccn,
	    mccnName = commercialTariffResult.mccnName,
	    currency = commercialTariffResult.currency,
	    paymentData = commercialTariffResult.paymentData,
	    debitCommission = commercialTariffResult.debitCommission,
	    creditCommission = commercialTariffResult.creditCommission;
	var idTransaction = state.idTransaction,
	    validateCrmClientData = state.validateCrmClientData,
	    rucValidation = state.rucValidation,
	    osvType = state.osvType,
	    businessSchedule = state.businessSchedule,
	    legalRepresentativeData = state.legalRepresentativeData,
	    virtual = state.virtual,
	    installationSchedule = state.installationSchedule,
	    posSelected = state.posSelected,
	    afilliationSummary = state.afilliationSummary,
	    applyToCodeQR = state.applyToCodeQR;
	var _state$businessData2 = state.businessData,
	    commerceData = _state$businessData2.commerceData,
	    commercialAddress = _state$businessData2.commercialAddress,
	    administrativeAddress = _state$businessData2.administrativeAddress;
	var ruc = rucValidation.ruc,
	    businessName = rucValidation.businessName;
	var pos = posSelected.pos,
	    TipoConexion = posSelected.TipoConexion;


	creditCommission = creditCommission || 3.99;
	debitCommission = debitCommission || 2.99;

	var developer = pos == virtualPosEnum.PAGO_WEB ? virtual.webSite.developer : virtual.app.developer;
	var integration = pos == virtualPosEnum.PAGO_WEB ? virtual.webSite.integration : virtual.app.integration;

	var subReason = void 0,
	    reason = void 0,
	    subProductCode = void 0,
	    equipmentType = void 0,
	    idTradePlan = '',
	    isMulticommerce = false;

	switch (Number(state.osvType.osvType)) {
		// individual
		case 1:
			reason = isNotBimoney ? 'INS' : 'INS_MLT';
			subReason = isNotBimoney ? 'INS_0' : 'INS_MLT';
			break;
		// multicomercio
		case 2:
			reason = 'INS';
			subReason = 'INS_MLT';
			isMulticommerce = true;
			mccn = '0100';
			break;
		// código hijo
		case 3:
			reason = 'RGS';
			subReason = 'RGS_0';
			mccn = '0100';
			break;
	}

	if (isVirtual) {
		idTradePlan = 'CE';
		switch (pos) {
			case virtualPosEnum.PAGO_APP:
				subProductCode = subProductEnum.PAGO_APP;
				idTradePlan += 'APP0000' + (currency === currencyTypeEnum.SOLES ? '3' : '4');
				break;
			case virtualPosEnum.PAGO_LINK:
				subProductCode = subProductEnum.PAGO_LINK;
				idTradePlan += 'PAGLIK0' + (currency === currencyTypeEnum.SOLES ? '7' : '8');
				break;
			case virtualPosEnum.PAGO_WEB:
				subProductCode = subProductEnum.PAGO_WEB;
				idTradePlan += 'PAGOWB0' + (currency === currencyTypeEnum.SOLES ? '5' : '6');
				break;
		}
	} else subProductCode = 'BP';

	switch (TipoConexion) {
		case 'RTC':
			equipmentType = 'DPA';
			break;
		case 'IPC':
			equipmentType = 'PIP';
			break;
		case 'CEL':
			equipmentType = 'CLX';
			break;
		default:
			equipmentType = '';
	}

	var LegalBirthDate = moment(legalRepresentativeData.birthdate).format('YYYY-MM-DD');
	var equipmentQuantity = 0;

	if (state.afilliationSummary.equipment) {
		equipmentQuantity = parseInt(state.afilliationSummary.equipment.value, 10);
		if (isNaN(equipmentQuantity)) equipmentQuantity = 1;
	}

	var request = {
		idTransaction: idTransaction,
		idTradePlan: idTradePlan,
		ciiuSunat: validateCrmClientData && (validateCrmClientData.SIC + ' - ' + validateCrmClientData.Desc).trim(),
		ruc: ruc,
		lastRequestToSunatDate: rucValidation.consultDate,
		businessName: businessName,
		commercialName: commerceData.tradeName,
		// businessName: commerceData.commercialBusiness ? commerceData.commercialBusiness.Description : '',
		businessEmail: commerceData.email,
		personalDataTreatment: afilliationSummary.authorizePersonalDataTreatment,
		currency: currency === currencyTypeEnum.DOLARES ? 'DOL' : 'SOL',
		parentCommerceCode: osvType.commercialCode ? osvType.commercialCode : '',
		subProductCode: subProductCode,
		productCode: isVirtual ? 'CE' : 'BS',
		mcci: mcci,
		mccnName: mccnName,
		mccn: mccn,
		bankCode: paymentData.bankName,
		bankAccountType: paymentData.accountType,
		bankAccountNumber: paymentData.accountNumber,
		bankAccountNumberFormatted: paymentData.alternativeAccountNumber,
		creditCommission: creditCommission,
		debitCommission: debitCommission,
		isMulticommerce: isMulticommerce,
		administrativeAddress: {
			department: administrativeAddress.department.UbiDep,
			province: administrativeAddress.province.UbiPro,
			district: administrativeAddress.district.UbiDis,
			typeOfRoad: (administrativeAddress.typeOfRoad || { Code: '' }).Code,
			nameOfRoad: administrativeAddress.nameOfRoad,
			numberOfRoad: administrativeAddress.numberOfRoad,
			// plusCode: administrativeAddress.plusCode,
			km: administrativeAddress.km,
			block: administrativeAddress.block,
			allotment: administrativeAddress.allotment,
			interiorType: (administrativeAddress.interiorType || { Code: '' }).Code,
			interior: administrativeAddress.interior,
			reference: administrativeAddress.reference,
			typeUrbanHabilitation: administrativeAddress.typeUrbanHabilitation,
			urbanHabilitation: administrativeAddress.urbanHabilitation,
			cellPhone: administrativeAddress.cellPhone,
			prefix: administrativeAddress.prefix,
			phone: administrativeAddress.landline
		},
		commercialAddress: {
			department: commercialAddress.department.UbiDep,
			province: commercialAddress.province.UbiPro,
			district: commercialAddress.district.UbiDis,
			typeOfRoad: (commercialAddress.typeOfRoad || { Code: '' }).Code,
			nameOfRoad: commercialAddress.nameOfRoad,
			numberOfRoad: commercialAddress.numberOfRoad,
			// plusCode: commercialAddress.plusCode,
			km: commercialAddress.km,
			block: commercialAddress.block,
			allotment: commercialAddress.allotment,
			interiorType: (commercialAddress.interiorType || { Code: '' }).Code,
			interior: commercialAddress.interior,
			reference: commercialAddress.reference,
			typeUrbanHabilitation: commercialAddress.typeUrbanHabilitation,
			urbanHabilitation: commercialAddress.urbanHabilitation,
			cellPhone: commercialAddress.cellPhone,
			prefix: commercialAddress.prefix,
			phone: commercialAddress.landline
		},
		scheduleAttention: {
			daysNumber: Array.isArray(businessSchedule.schedule) ? businessSchedule.schedule.filter(function (day) {
				return day > -1;
			}) : [],
			initTime: businessSchedule.startTime,
			endTime: businessSchedule.endTime
		},
		legalRepresentative: {
			fullName: legalRepresentativeData.firstName,
			paternalName: legalRepresentativeData.paternalName,
			maternalName: legalRepresentativeData.maternalName,
			documentType: mapToVirtualValue('tipoDocumento', legalRepresentativeData.documentType.Code),
			documentNumber: legalRepresentativeData.documentNumber,
			phone: legalRepresentativeData.secondPhone,
			cellPhone: legalRepresentativeData.cellPhone,
			email: legalRepresentativeData.email,
			birthdate: LegalBirthDate,
			lastRequestToSunatDate: legalRepresentativeData.consultDate
		},
		administrativePlatformUser: {
			fullName: virtual.user.fullname,
			email: virtual.user.email,
			phone: virtual.user.phone
		},
		app: {
			name: virtual.app.name,
			link: virtual.app.link,
			platform: virtual.app.platform ? (masterData.platform.find(function (p) {
				return p.value === virtual.app.platform;
			}) || { text: null }).text : null,
			integration: integration.paymentForm
		},
		developer: {
			developmentType: developer.developmentType ? (masterData.development.find(function (p) {
				return p.value === developer.developmentType;
			}) || { text: null }).text : null,
			company: developer.company ? developer.company : null,
			fullName: developer.fullname ? developer.fullname : null,
			email: developer.email ? developer.email : null,
			phone: developer.phone ? developer.phone : null
		},
		websiteUrl: virtual.webSite.url,
		subReason: subReason,
		reason: reason,
		equipmentQuantity: equipmentQuantity,
		connectionType: TipoConexion,
		installationContact: {
			fullName: ((installationSchedule.name || '') + ' ' + (installationSchedule.paternalLastname || '') + ' ' + (installationSchedule.maternalLastname || '')).trim(),
			cellphone: installationSchedule.phone,
			email: installationSchedule.email,
			phone: installationSchedule.phone
		},
		channelName: user.channelName,
		subChannelName: user.subChannelName,
		groupChannelName: user.groupChannelName,
		equipmentType: equipmentType,
		dues: afilliationSummary.dues ? afilliationSummary.dues.value : null,

		applyToCodeQR: applyToCodeQR,
		originPlatform: 'HWA',
		state: '03',
		fieldProvider: 'SCRPDC',
		mccNational: '4444'
	};

	console.log('request codigo QR: ', request);

	return request;
};


//////////////////
// WEBPACK FOOTER
// ./src/mappers/generate-commerce-code.js
// module id = ./src/mappers/generate-commerce-code.js
// module chunks = 34